import {
  RESET_PASSWORD_CHAUFFEUR,
  RESET_PASSWORD_CHAUFFEUR_SUCCESS,
  RESET_PASSWORD_CHAUFFEUR_ERROR,
  RESET_PASSWORD_CHAUFFEUR_EMPTY,
} from '../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ResetPasswordChauffeur = (state = initialState, action) => {
  switch (action.type) {
    case RESET_PASSWORD_CHAUFFEUR:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case RESET_PASSWORD_CHAUFFEUR_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case RESET_PASSWORD_CHAUFFEUR_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case RESET_PASSWORD_CHAUFFEUR_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ResetPasswordChauffeur;
